module.exports = __webpack_public_path__ + "static/media/user5-neil-briody.d6cd7aa8.jpg";